export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src="/emblem.png" alt="Upgrade Law emblem" className={className} />
);

export const Logo = ({ light = false, className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <img src="/emblem.png" alt="Upgrade Law" className="h-10 w-10 shrink-0" />
    <span className="flex flex-col leading-none">
      <span
        className={`font-sans text-[1.05rem] font-extrabold uppercase tracking-[0.05em] ${
          light ? "text-white" : "text-navy"
        }`}
      >
        Upgrade <span className={light ? "text-[#6D8FFF]" : "text-[#013C9D]"}>Law</span>
      </span>
      <span
        className={`mt-1 font-mono text-[8.5px] uppercase tracking-[0.3em] ${
          light ? "text-white/50" : "text-steel/70"
        }`}
      >
        Legal Advisory — India
      </span>
    </span>
  </span>
);
